import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class EditableQuestion extends React.Component {

    constructor(props) {
        super(props);

        this.answerIDs = [];
        this.questionID = this.props.id;
        this.updateImage = false;
        this.state = {
            text: "",
            explanation: "",
            imagePath: "",
            image: "",
            answers: [],
            editing: false,
            errorMessage: ""
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'question/' + this.questionID + '?Authentication=' + cookie
        ).then(response => {
            this.setState({
                text: response.data.records[0].text,
                imagePath: response.data.records[0].img_source,
                explanation: response.data.records[0].answer_explanation
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
        this.updateAnswers();
    }

    updateAnswers() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'question/' + this.questionID + '/answer?Authentication=' + cookie
        ).then(response => {
            this.setState({
                answers: response.data.records
            });
            this.answerIDs = [];
            response.data.records.map(answer => {
                this.answerIDs.push(answer.ID);
                return null;
            });
        }).catch(error => {
            this.answerIDs = [];
            this.props.CheckAuthError(error);
        });
    }

    saveQuestion() {
        if (this.state.answers.length === 0) {
            this.setState({
                errorMessage: "Es muss mindestens eine Antwort angegeben werden."
            });
            return null;
        }
        let manipulation = false;
        this.state.answers.map(answer => {
            if (answer.ID === -1) {
                return null;
            }
            if (this.answerIDs.indexOf(answer.ID) === -1) {
                manipulation = true;
            }
            return null;
        });
        if (manipulation) {
            this.setState({
                errorMessage: "Ein Fehler ist augetreten, die Antworten wurden zurückgesetzt. Es wird vermutet, dass der Quellcode der Seite manipuliert wurde."
            });
            this.updateAnswers();
            return null;
        }
        let minOneChecked = false;

        this.state.answers.map(answer => {
            if (answer.IS_TRUE) {
                minOneChecked = true;
            }
            return null;
        });
        if (this.state.text === "") {
            this.setState({
                errorMessage: "Sie müssen einen Fragentext eingeben."
            });
            return null;
        }
        let isAnswerTextNull = false;
        this.state.answers.map(answer => {
            if (answer.TEXT === "") {
                isAnswerTextNull = true;
            }
            return null;
        });
        if (isAnswerTextNull) {
            this.setState({
                errorMessage: "Sie müssen bei jeder Antwort einen Text angeben."
            });
            return null;
        }
        if (!minOneChecked) {
            this.setState({
                errorMessage: "Mindestens eine Antwort muss \"Richtig\" sein."
            });
            return null;
        }
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.put(Globals.EL_PATH + 'question/' + this.questionID + '?Authentication=' + cookie, {
            TEXT: this.state.text,
            ANSWER_EXPLANATION: this.state.explanation
        }).then(() => {
            this.state.answers.map((answer) => {
                if (answer.ID < 0) {
                    axios.post(Globals.EL_PATH + 'question/' + this.questionID + '/answer?Authentication=' + cookie, {
                        "TEXT": answer.TEXT,
                        "IS_TRUE": answer.IS_TRUE
                    }).then(() => {
                        this.componentDidMount();
                    }).catch(error => {
                        this.props.CheckAuthError(error);
                    });
                    return null;
                }
                axios.put(Globals.EL_PATH + 'answer/' + answer.ID + '?Authentication=' + cookie, {
                    TEXT: answer.TEXT,
                    IS_TRUE: answer.IS_TRUE
                }).catch(error => {
                    this.props.CheckAuthError(error);
                });
                return null;
            });
            if (this.state.image !== "" && this.updateImage) {
                let formData = new FormData();
                formData.append('file', this.state.image);
                axios.post(Globals.EL_PATH + 'question/' + this.questionID + '/picture?Authentication=' + cookie, formData,
                    {
                        headers:
                            {
                                'content-type':
                                    'multipart/form-data'
                            }
                    }).then(() => {
                    this.componentDidMount();
                }).catch(error => {
                    this.props.CheckAuthError(error);
                });
            }
            this.setState({
                editing: false
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    handleCheckedChange(index) {
        const answers = this.state.answers;
        answers[index].IS_TRUE = !answers[index].IS_TRUE;

        this.setState({
            answers: answers,
            errorMessage: ""
        });
    }

    handleAnswerTextChange(e, index) {
        const answers = this.state.answers;
        answers[index].TEXT = e.target.value;

        this.setState({
            answers: answers,
            errorMessage: ""
        });
    }

    deleteAnswer(e, index) {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.delete(Globals.EL_PATH + 'answer/' + this.state.answers[index].ID + '?Authentication=' + cookie
        ).then(() => {
            let answers = [];
            this.state.answers.map((answer, i) => {
                if (i !== index) {
                    answers.push(answer);
                }
                return null;
            });
            this.setState({
                answers: answers
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    handleTextChange(event) {
        this.setState({
            text: event.target.value,
            errorMessage: ""
        });
    }

    handleExplanationChange(event) {
        this.setState({
            explanation: event.target.value,
            errorMessage: ""
        });
    }

    addAnswer() {
        let answers = this.state.answers;
        answers.push({
            ID: -1,
            TEXT: "",
            IS_TRUE: false
        });
        this.setState({
            answers: answers
        });
    }

    removeImage() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.delete(Globals.EL_PATH + 'question/' + this.questionID + "/picture?Authentication=" + cookie
        ).then(() => {
            this.setState({
                imagePath: null,
                image: ""
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
        this.setState({
            imagePath: null,
            image: ""
        });
    }

    changeImage(e) {
        this.updateImage = true;
        this.setState({
            image: e.target.files[0]
        });
    }

    getImageBlock() {
        if (this.state.imagePath === null) {
            return (
                <div className="form-group">
                    <label>Bild hinzufügen</label>
                    <input type="file" accept="image/*" name="file" onChange={(e) => this.changeImage(e)}/>
                </div>
            );
        } else {
            return (
                <div className="form-group">
                    <label>Derzeitiges Bild:</label>
                    <p>{this.state.imagePath}</p>
                    <button className="btn btn-link no-padding" onClick={() => this.removeImage()}>Bild löschen</button>
                </div>
            );
        }
    }

    getErrorMessage() {
        if (this.state.errorMessage !== "") {
            return (
                <div className="alert alert-danger text-center margin-bottom-sm"><b>{this.state.errorMessage}</b></div>
            );
        }
        return null;
    }

    getRenderBlock() {
        if (this.state.editing) {
            return (
                <li className="list-group-item">
                    <div className="well well-sm editQuestion">
                        <div className="form-group">
                            <label>Fragentext</label>
                            <input type="text" className="form-control" value={this.state.text}
                                   onChange={(e) => this.handleTextChange(e)}/>
                        </div>
                        <div className="form-group">
                            <label>Erklärung</label>
                            <input type="text" className="form-control" value={this.state.explanation}
                                   onChange={(e) => this.handleExplanationChange(e)}/>
                        </div>
                        <label>Antworten</label>
                        {
                            this.state.answers.map((answer, index) => {
                                return (
                                    <div key={index} className="input-group margin-bottom-sm">
                                        <label className="checkbox-label input-group-addon"
                                               style={{marginRight: '0', lineHeight: '22px'}}>
                                            <input className="customCheckbox" type="checkbox" checked={answer.IS_TRUE}
                                                   onChange={() => this.handleCheckedChange(index)}/>
                                            <span className="label-text"/>
                                        </label>
                                        <input type="text" value={answer.TEXT}
                                               onChange={(e) => this.handleAnswerTextChange(e, index)}
                                               className="form-control"/>
                                        <span
                                            className="input-group-addon glyphicon glyphicon glyphicon-trash removeQuestion"
                                            onClick={(e) => this.deleteAnswer(e, index)}/>
                                    </div>
                                );
                            })
                        }
                        <button className="btn btn-default center-block" type="button"
                                onClick={() => this.addAnswer()}>Antwort hinzufügen
                        </button>
                        {this.getImageBlock()}
                    </div>
                    {this.getErrorMessage()}
                    <button className="btn btn-success center-block saveQuestionButton" type="button"
                            onClick={() => this.saveQuestion()}>Frage speichern
                    </button>
                </li>
            );
        } else {
            return (
                <li className="list-group-item">
                    <h5 className="text-center no-margin">
                        {this.state.text}
                        <p className="btn btn-link no-padding padding-sm" type="button"
                           onClick={() => this.setState({editing: !this.state.editing})}>Frage bearbeiten</p>
                        <p className="btn btn-danger padding-xs" type="button"
                           onClick={() => {
                               this.props.onDelete(this.questionID, this.state.text)
                           }}>
                            <span className="glyphicon glyphicon glyphicon-trash deleteQuestionButton"/>
                        </p>
                    </h5>
                </li>
            );
        }
    }

    render() {
        return (this.getRenderBlock());
    }

}



// WEBPACK FOOTER //
// ./src/admin/EditableQuestion.js